import { render, staticRenderFns } from "./DialogPaymentDetail.pug?vue&type=template&id=60f2f4cc&lang=pug&"
import script from "./DialogPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./DialogPaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports